const desigantionReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default desigantionReducer;